import type { Motive } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MotivesService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getMotives = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, Motive[]>({
      method: 'GET',
      url: '/api/app/motives/motives',
    },
    { apiName: this.apiName,...config });
}